// ==========================================================================
// Footer Scroll Buttons
// ==========================================================================

class FooterScrollButtons {
	constructor() {
		this.scrollTopBtn = document.querySelector('.footer_btn_scrollTop');
		this.scrollStoreBtn = document.querySelector('.footer_btn_scrollStore');
		this.header = document.querySelector('.header');
		this.footer = document.querySelector('.footer');

		this.init();
	}

	init() {
		if (!this.scrollTopBtn && !this.scrollStoreBtn) return;

		// ページトップへスクロールボタン
		if (this.scrollTopBtn) {
			this.scrollTopBtn.addEventListener('click', () => {
				this.scrollToTop();
			});
		}

		// 取り扱い店舗へスクロールボタン
		if (this.scrollStoreBtn) {
			this.scrollStoreBtn.addEventListener('click', () => {
				this.scrollToStores();
			});

			// フッターが画面内に入ったらボタンをフェードアウト
			this.observeFooter();
		}
	}

	observeFooter() {
		if (!this.footer || !this.scrollStoreBtn) return;

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						// フッターが画面内に入ったらフェードアウト
						this.scrollStoreBtn.classList.add('is-transparent');
					} else {
						// フッターが画面外に出たら表示
						this.scrollStoreBtn.classList.remove('is-transparent');
					}
				});
			},
			{
				threshold: 0,
				rootMargin: '0px'
			}
		);

		observer.observe(this.footer);
	}

	scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	scrollToStores() {
		const storesSection = document.getElementById('stores');
		if (!storesSection) return;

		// ヘッダーの高さを取得
		const headerHeight = this.header ? this.header.offsetHeight : 0;
		const offset = 20; // 追加のオフセット

		// スクロール位置を計算
		const elementPosition = storesSection.getBoundingClientRect().top + window.pageYOffset;
		const offsetPosition = elementPosition - headerHeight - offset;

		// スムーススクロール
		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		});
	}
}

// 初期化
document.addEventListener('DOMContentLoaded', () => {
	new FooterScrollButtons();
});

export default FooterScrollButtons;
